<button
  id="deleteModal1"
  data-toggle="modal"
  data-target="#deleteDeviceModel1"
  [hidden]="true">
  Modal
</button>
<button
  id="deleteModal2"
  data-toggle="modal"
  data-target="#deleteDeviceModel2"
  [hidden]="true">
  Modal
</button>

<div
  id="{{modalId}}"
  class="modal fade cdm-modal"
  data-keyboard="false"
  data-backdrop="static"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content cdm-modal__content">
      <header class="cdm-modal__header">
        <div class="cdm-modal__title-wrap">
          <span class="cdm-modal__ico cdm-modal__ico--{{ type }}" aria-hidden="true">
            <i class="fa fa-exclamation-triangle"></i>
          </span>
          <h5 class="cdm-modal__title">{{ title }}</h5>
        </div>
        <button
          type="button"
          id="{{modalCloseId}}"
          #btnClose
          class="cdm-modal__close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="cancelConfirm()"
        >
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </header>

      <div class="cdm-modal__body">
        <div class="cdm-modal__message">
          <h4 class="cdm-modal__question">Are you sure?</h4>
          @if (!displayMessage) {
            <p class="cdm-modal__text">
              This action cannot be undone. Please type “confirm” in the box below to continue.
            </p>
          }
          @if (displayMessage) {
            <p class="cdm-modal__text">{{ displayMessage }}</p>
          }
        </div>

        @if (!hideInputconfirm) {
          <div class="cdm-modal__confirm-field">
            <input
              type="text"
              name="confirm"
              id="confirm"
              class="cdm-modal__input"
              [(ngModel)]="confirmText"
              autocomplete="off"
              tabindex="2"
              placeholder="Type confirm"
              required
            />
          </div>
        }

        <div class="cdm-modal__actions">
          <button
            #btnClose
            type="button"
            class="cdm-modal__btn cdm-modal__btn--secondary"
            data-dismiss="modal"
            (click)="cancelConfirm()"
          >
            Cancel
          </button>
          @if (!hideInputconfirm) {
            <button
              [disabled]="disableBtn || !confirmed"
              type="button"
              (click)="confirmDelete()"
              class="cdm-modal__btn cdm-modal__btn--{{ type }}"
            >
              @if (primaryAction) {
                <span>Confirm</span>
              }
              @if (!primaryAction) {
                <span>{{ displayText }}</span>
              }
            </button>
          }
          @if (hideInputconfirm) {
            <button
              [disabled]="disableBtn"
              type="button"
              (click)="confirmDelete()"
              class="cdm-modal__btn cdm-modal__btn--{{ type }}"
            >
              @if (primaryAction) {
                <span>Confirm</span>
              }
              @if (!primaryAction) {
                <span>{{ displayText }}</span>
              }
            </button>
          }
        </div>
      </div>
    </div>
  </div>
</div>
